import environment from "./endpoints";

const REL_API_URL = "https://rel-admin-dmp.insigit.com";

export default environment(REL_API_URL);

